import {
  ReadOnlyElementContainer,
} from "components/elements/ElementContainer";
import { useAppSelector } from "hooks/redux";
import { filter, sortBy } from "lodash";
import { selectRfi } from "store/rfiSlice";
import {
  SectionGroup,
  elementTypes,
  fieldTypes,
  sectionNames
} from "../../types/RfiTypes";
import { vendorNavPages } from "./VendorNav";
import { selectVendorResponse } from "store/vendorResponseSlice";
import { VendorUserType } from "auth/VendorAuth/vendorUserSlice";

interface IRfiVendorAllProps {
  user?: VendorUserType;
  setSelectedPage?: any;
  readOnly?: boolean;
}

const VendorRfiDetails = (props: IRfiVendorAllProps) => {
  // constants
  let questionNumber: number = 0;

  //hooks
  const rfi = useAppSelector(selectRfi);
  const vendorResponse = useAppSelector(selectVendorResponse)

  // handlers
  const page1 = filter(rfi.describe, (e: any) => {
    const eSections = e.sections.find((s: any) => {
      return s.sectionGroupName === `${sectionNames.DESCRIBE}`;
    });

    return (
      e.elementType === elementTypes.FIELD &&
      e.fieldType !== fieldTypes.GUIDANCETEXT &&
      eSections?.sectionGroupName === `${sectionNames.DESCRIBE}`
    );
  });

  var result = sortBy(page1, (element: any) => {
    return element.sections.find(
      (x: SectionGroup) => x.sectionGroupName === `${sectionNames.DESCRIBE}`
    )?.sequence;
  });

  // Render
  return (
    <div className="rfi-content">
      {!props.user || (props.user && !props.user.isAuthenticated) && (
        <div className="alert alert-primary" role="alert">
          This is a read-only view of this RFI. To ask questions or to work on a
          response, sign in using your login.gov id and password using the Sign
          In link in the upper right of the screen. Signing in will
          automatically register your interest in this RFI and you will receive
          email alerts for updates such as a new amendment or cancellation. If
          you do not currently have a login.gov ID, you may register for one
          after clicking Sign In.
        </div>
      )}
      {/* Describe fields */}
      {result.map((element: any, i: number) => {
        return (
          <ReadOnlyElementContainer
            key={i}
            element={element}
            questionNumber={questionNumber}
            readOnly
          />
        );
      })}            
        <div className="mt-5">
          <button
            className="btn btn-primary m-1"
            role="button"
            onClick={() =>
              props.setSelectedPage(vendorNavPages.UNAUTH_ATTACHMENTS)
            }
          >
            Attachments <i className="fa-solid fa-chevron-right"></i>
          </button>
        </div>      
    </div>
  );
};

export default VendorRfiDetails;
